import { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export default function LangSwitcher() {
  const { i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return;
    function handle(e) {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    }
    document.addEventListener('mousedown', handle);
    return () => document.removeEventListener('mousedown', handle);
  }, [open]);

  function setLang(lng) {
    i18n.changeLanguage(lng);
    setOpen(false);
  }

  const current = i18n.language?.slice(0, 2) ?? 'en';

  return (
    <div className="app-lang-sw" ref={ref}>
      <button className="app-icon-btn app-lang-btn" onClick={() => setOpen(o => !o)} title="Language">
        <i className="ph ph-globe" />
        <span className="app-lang-label">{current.toUpperCase()}</span>
      </button>
      {open && (
        <div className="app-lang-drop">
          {[
            { code: 'en', label: 'EN', flag: 'fi-gb' },
            { code: 'fr', label: 'FR', flag: 'fi-fr' },
          ].map(({ code, label, flag }) => (
            <button
              key={code}
              className={`app-lang-option${current === code ? ' active' : ''}`}
              onClick={() => setLang(code)}
            >
              <span className={`fi ${flag}`} />
              {label}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
